import { RouterConfig } from '@angular/router';
import { TowersTraconsImportStepsComponent } from './towers-tracons-import-steps.component';


export const TowersTraconsImportStepsRoutes: RouterConfig = [
  //all Growthrates routes here
  {path: 'towers-tracons-import-steps', component: TowersTraconsImportStepsComponent},

];


/** WEBPACK FOOTER **
 ** ./app/system-management/towers-tracons-import/towers-tracons-import-steps/towers-tracons-import-steps.routes.ts
 **/